import React from 'react';
import { useEyeMove } from "../hooks/useEyeMove.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Illustration403() {
  const leftEye = {
    x: 161,
    y: 59
  };
  const rightEye = {
    x: 188,
    y: 59
  };
  const {
    svg,
    translatedLeftEye,
    translatedRightEye
  } = useEyeMove({
    leftEye,
    rightEye
  });
  return /*#__PURE__*/_jsx("svg", {
    ref: svg,
    width: "332",
    height: "130",
    viewBox: "0 0 332 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M0.619072 79.7149L56.2281 0.619232H83.1369V83.3946H98.384V104.547H83.1369V129.381H60.7125V104.547H0.619072V79.7149ZM60.7125 83.3933V30.05L23.041 83.3946L60.7125 83.3933Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.2381"
      }), /*#__PURE__*/_jsx("path", {
        d: "M121.333 65C121.333 31.3238 146.447 10.3789 174.25 10.3789C202.052 10.3789 227.169 31.33 227.169 65C227.169 98.67 202.055 119.62 174.25 119.62C146.444 119.62 121.333 98.6687 121.333 65Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.2381",
        strokeLinecap: "round"
      }), /*#__PURE__*/_jsx("path", {
        d: "M255.729 94.9867C259.165 99.1376 263.477 102.476 268.357 104.763C273.236 107.051 278.561 108.229 283.95 108.214C299.825 108.214 307.762 100.277 307.762 90.5778C307.762 80.8786 299.825 72.9386 284.833 72.9386H271.603V52.6525H284.834C296.297 52.6525 303.353 45.5953 303.353 36.7801C303.353 27.9648 297.178 21.7868 284.834 21.7868C269.84 21.7868 259.257 33.2527 259.257 33.2527L244.264 19.1385C249.49 13.3191 255.88 8.66306 263.021 5.47226C270.162 2.28145 277.894 0.627119 285.715 0.616547C310.409 0.616547 326.283 17.3742 326.283 35.0133C326.283 55.297 306.879 61.4702 306.879 61.4702C306.879 61.4702 330.693 68.172 330.693 91.4556C330.693 111.739 313.054 129.378 285.714 129.378C255.729 129.378 240.735 109.975 240.735 109.975L255.729 94.9867Z",
        fill: "#CCD7CB",
        stroke: "#272727",
        strokeWidth: "1.2381"
      }), /*#__PURE__*/_jsx("path", {
        d: "M161.512 59.02C162.847 59.02 163.929 57.938 163.929 56.6032C163.929 55.2685 162.847 54.1865 161.512 54.1865C160.177 54.1865 159.095 55.2685 159.095 56.6032C159.095 57.938 160.177 59.02 161.512 59.02Z",
        fill: "#333333",
        transform: `translate(${translatedLeftEye?.x} ${translatedLeftEye?.y})`
      }), /*#__PURE__*/_jsx("path", {
        d: "M188.501 58.9903C189.836 58.9903 190.918 57.9082 190.918 56.5735C190.918 55.2388 189.836 54.1567 188.501 54.1567C187.167 54.1567 186.085 55.2388 186.085 56.5735C186.085 57.9082 187.167 58.9903 188.501 58.9903Z",
        fill: "#333333",
        transform: `translate(${translatedRightEye?.x} ${translatedRightEye?.y})`
      }), /*#__PURE__*/_jsx("path", {
        d: "M169.478 74.568C169.932 73.4922 170.691 72.5722 171.66 71.9205C172.629 71.2688 173.767 70.9136 174.934 70.8984C176.102 70.8831 177.249 71.2085 178.235 71.8347C179.22 72.4609 180.002 73.3608 180.485 74.4244",
        stroke: "#272727",
        strokeWidth: "1.2381",
        strokeLinecap: "round"
      })]
    })
  });
}